import React from 'react'

import { assertUnreachable } from 'lib/assertions'
import { LIVE_PRODUCTS } from 'lib/products/constants'
import { headerTypes } from 'components/Header/types'
import type { Styles } from 'components/Header/Full/PrimaryNavigation'
import HeaderCompact from 'components/Header/Compact'
import HeaderFull from 'components/Header/Full'
import HeaderMinimal from 'components/Header/Minimal'

const Header = ({
  color,
  customHeader,
  mobileColor,
  selectedProduct,
  showLoginLink = false,
  telephoneNumber = '',
  hideFarewillLogo = false,
  farewillLogoLink,
  hideTelephoneNumber = false,
  style = 'default',
  type = 'full',
}: {
  color?: string
  customHeader?: React.ReactNode
  mobileColor?: string
  selectedProduct: (typeof LIVE_PRODUCTS)[number]
  showLoginLink?: boolean
  telephoneNumber?: string
  hideFarewillLogo?: boolean
  farewillLogoLink?: string
  hideTelephoneNumber?: boolean
  style?: Styles
  type?: (typeof headerTypes)[number]
}): React.ReactElement => {
  if (customHeader) {
    return customHeader as React.ReactElement
  }

  switch (type) {
    case 'compact':
      return (
        <HeaderCompact
          color={color}
          headerFarewillLogoLink={farewillLogoLink}
          hideFarewillLogo={hideFarewillLogo}
          hideTelephoneNumber={hideTelephoneNumber}
          selectedProduct={selectedProduct}
          telephoneNumber={telephoneNumber}
        />
      )
    case 'full':
      return (
        <HeaderFull
          color={color}
          headerFarewillLogoLink={farewillLogoLink}
          headerStyle={style}
          mobileColor={mobileColor}
          selectedProduct={selectedProduct}
          showLoginLink={showLoginLink}
          telephoneNumber={telephoneNumber}
        />
      )
    case 'minimal':
      return <HeaderMinimal color={color} hideFarewillLogo={hideFarewillLogo} />
    default:
      return assertUnreachable(type)
  }
}

export default Header
